import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FilterItemDto} from "../../../shared/models/misc";
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-toggle',
    imports: [CommonModule],
    templateUrl: './toggle.component.html',
    styleUrls: ['./toggle.component.scss'],
})
export class ToggleComponent {
  @Input() options: FilterItemDto[] = [];
  @Input() selectedOption!: FilterItemDto;
  @Output() selectedOptionChange = new EventEmitter<FilterItemDto>();

  onToggleChange(event: Event) {
    if (!this.options?.length || this.options.length < 2) return;
    const checked = (event.target as HTMLInputElement).checked;
    const next = checked ? this.options[0] : this.options[1];
    this.selectedOption = next;

    this.selectedOptionChange.emit(next);
  }
}
